import { useLocalStorage } from '@/hooks/useLocalStorage'
import { ReactNode, useEffect, useState } from 'react'
import { ColorScheme, ColorSchemeContext } from './colorSchemeContext'

type Props = {
  children: ReactNode
}

export const ColorSchemeProvider = ({ children }: Props) => {
  const [localColorScheme, setLocalColorScheme] = useLocalStorage<ColorScheme>(
    'color-scheme',
    ColorScheme.System
  )

  const [colorScheme, setColorScheme] = useState<ColorScheme>(localColorScheme)

  useEffect(() => {
    setLocalColorScheme(colorScheme)
  }, [setLocalColorScheme, colorScheme])

  const isDarkMode =
    colorScheme === ColorScheme.Dark ||
    (colorScheme === ColorScheme.System &&
      window.matchMedia('(prefers-color-scheme: dark)').matches)

  return (
    <ColorSchemeContext.Provider
      value={{ colorScheme, setColorScheme, isDarkMode }}
    >
      <div className={isDarkMode ? 'dark' : ''}>{children}</div>
    </ColorSchemeContext.Provider>
  )
}
